module.exports = __webpack_public_path__ + "sv.3d8a8502a46da4864b91.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/sv.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/sv.svg
// module chunks = styles